"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useLogin = void 0;
var _react = require("react");
var _api = require("./api");
var _pushEventToGTM = require("../../commonHelpers/pushEventToGTM");
var _sendErrorToSentry = require("ErrorBoundary/sendErrorToSentry");
var _events = require("../../ptlSignup/events");
var _constants = require("../../teacherDashboard/utils/constants");
var _common = require("../../teacherDashboard/teacher/config/common");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var resendOTPTimer = null;
var getParams = function getParams() {
  var queryParams = new URLSearchParams(window.location.search);
  var token = queryParams.get("token");
  try {
    return token ? JSON.parse(atob(token)) : {};
  } catch (e) {
    (0, _sendErrorToSentry.sendErrorToSentry)(e, {
      token: token
    });
  }
  return {};
};
var useLogin = exports.useLogin = function useLogin(_ref) {
  var _ref$primaryInputLabe = _ref.primaryInputLabel,
    primaryInputLabel = _ref$primaryInputLabe === void 0 ? "Email" : _ref$primaryInputLabe,
    _ref$showSocialLogin = _ref.showSocialLogin,
    showSocialLogin = _ref$showSocialLogin === void 0 ? true : _ref$showSocialLogin,
    _ref$sendEvent = _ref.sendEvent,
    sendEvent = _ref$sendEvent === void 0 ? function (clickedOn) {} : _ref$sendEvent,
    _ref$source = _ref.source,
    source = _ref$source === void 0 ? null : _ref$source,
    _ref$isPtlFlow = _ref.isPtlFlow,
    isPtlFlow = _ref$isPtlFlow === void 0 ? false : _ref$isPtlFlow;
  var params = getParams();
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    otpLogin = _useState2[0],
    setOTPLogin = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    otpSent = _useState4[0],
    setOTPSent = _useState4[1];
  var _useState5 = (0, _react.useState)(""),
    _useState6 = _slicedToArray(_useState5, 2),
    otp = _useState6[0],
    setOTP = _useState6[1];
  var _useState7 = (0, _react.useState)(0),
    _useState8 = _slicedToArray(_useState7, 2),
    timer = _useState8[0],
    setTimer = _useState8[1];
  var _useState9 = (0, _react.useState)(params === null || params === void 0 ? void 0 : params.masked_email),
    _useState0 = _slicedToArray(_useState9, 2),
    email = _useState0[0],
    setEmail = _useState0[1];
  var _useState1 = (0, _react.useState)(""),
    _useState10 = _slicedToArray(_useState1, 2),
    password = _useState10[0],
    setPassword = _useState10[1];
  var _useState11 = (0, _react.useState)(null),
    _useState12 = _slicedToArray(_useState11, 2),
    error = _useState12[0],
    setError = _useState12[1];
  var _useState13 = (0, _react.useState)(null),
    _useState14 = _slicedToArray(_useState13, 2),
    intentId = _useState14[0],
    setIntentId = _useState14[1];
  var _useState15 = (0, _react.useState)(false),
    _useState16 = _slicedToArray(_useState15, 2),
    showResendSuccessMsg = _useState16[0],
    setShowResendSuccessMsg = _useState16[1];
  var ifEmailExistInLS = localStorage.getItem('email-entered');
  var _useState17 = (0, _react.useState)((params === null || params === void 0 ? void 0 : params.referral_type) === _constants.InvitationSources.copy_link ? "Student selection screen" : "Sign up link"),
    _useState18 = _slicedToArray(_useState17, 2),
    fromPage = _useState18[0],
    setFromPage = _useState18[1];
  var _useState19 = (0, _react.useState)({
      typed: false,
      pasted: false
    }),
    _useState20 = _slicedToArray(_useState19, 2),
    emailEvents = _useState20[0],
    setEmailEvents = _useState20[1];
  var _useState21 = (0, _react.useState)({
      typed: false,
      pasted: false
    }),
    _useState22 = _slicedToArray(_useState21, 2),
    passwordEvents = _useState22[0],
    setPasswordEvents = _useState22[1];
  var _useState23 = (0, _react.useState)({
      referrerPage: "",
      invitationSource: ""
    }),
    _useState24 = _slicedToArray(_useState23, 2),
    referralData = _useState24[0],
    setReferralData = _useState24[1];
  (0, _react.useEffect)(function () {
    if (ifEmailExistInLS) {
      setEmail(ifEmailExistInLS);
      localStorage.removeItem('email-entered');
    }
    var referrerPage = _constants.REFERRER_PAGE_MAP[params === null || params === void 0 ? void 0 : params.referrer_code] || "default";
    var invitationSource = (params === null || params === void 0 ? void 0 : params.referral_type) || "";
    setReferralData({
      referrerPage: referrerPage,
      invitationSource: invitationSource
    });
    return function () {
      if (resendOTPTimer) {
        resendOTPTimer = null;
        clearInterval(resendOTPTimer);
      }
    };
  }, []);
  (0, _react.useEffect)(function () {
    if (isPtlFlow) {
      if (otpLogin) {
        (0, _events.viewedLoginViaOtpByClassroomLinkedParentEvent)({
          fromPage: fromPage,
          referrerPage: (referralData === null || referralData === void 0 ? void 0 : referralData.referrerPage) || _constants.REFERRER_PAGE_MAP[params === null || params === void 0 ? void 0 : params.referrer_code] || "default",
          invitationSource: (referralData === null || referralData === void 0 ? void 0 : referralData.invitationSource) || (params === null || params === void 0 ? void 0 : params.referral_type)
        });
      } else {
        var assignmentDueInDays = params !== null && params !== void 0 && params.nearest_due_date && (params === null || params === void 0 ? void 0 : params.nearest_due_date) !== "null" ? String((0, _common.DateDiffInDays)(new Date(), new Date(params === null || params === void 0 ? void 0 : params.nearest_due_date))) : "na";
        var viewedDueDateOnInvitation = params.view_due_date === "true" ? true : false;
        var totalAssignmentCount = params !== null && params !== void 0 && params.task_count && (params === null || params === void 0 ? void 0 : params.task_count) !== "null" ? Number(params.task_count || 0) : 0;
        (0, _events.viewedPtlParentLoginScreenEvent)({
          fromPage: fromPage,
          ptlFlow: params !== null && params !== void 0 && params.user_id ? "PTL student login" : "PTL student linking",
          referrerPage: (referralData === null || referralData === void 0 ? void 0 : referralData.referrerPage) || _constants.REFERRER_PAGE_MAP[params === null || params === void 0 ? void 0 : params.referrer_code] || "default",
          invitationSource: (referralData === null || referralData === void 0 ? void 0 : referralData.invitationSource) || (params === null || params === void 0 ? void 0 : params.referral_type),
          assignmentDueInDays: assignmentDueInDays,
          viewedDueDateOnInvitation: viewedDueDateOnInvitation,
          totalAssignmentCount: totalAssignmentCount
        });
      }
    }
  }, [otpLogin]);
  var setOTPTimer = function setOTPTimer() {
    var timeInSeconds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 59;
    if (!resendOTPTimer) {
      setTimer(timeInSeconds);
      resendOTPTimer = setInterval(function () {
        setTimer(function (count) {
          if (count == 1) {
            clearInterval(resendOTPTimer);
            resendOTPTimer = null;
          }
          return count - 1;
        });
      }, 1000);
    }
  };
  var sendOTP = function sendOTP() {
    if (isPtlFlow && intentId) {
      (0, _events.interactedLoginViaOtpByClassroomLinkedParentEvent)(_objectSpread({
        clickedOn: "Resend code",
        interactionDetails: "",
        otpEntered: (otp === null || otp === void 0 ? void 0 : otp.length) === 6
      }, referralData));
    }
    if (email !== null && email !== void 0 && email.length) {
      setError(null);
      _api.APIS[intentId ? "resendOTP" : "sendOTP"](email, intentId, params === null || params === void 0 ? void 0 : params.user_id).then(function (res) {
        var _res$data;
        if (resendOTPTimer) {
          clearInterval(resendOTPTimer);
          resendOTPTimer = null;
        }
        setOTP("");
        setOTPTimer();
        setOTPSent(true);
        if (intentId) {
          setShowResendSuccessMsg(true);
          setTimeout(function () {
            setShowResendSuccessMsg(false);
          }, 5000);
        }
        if (res !== null && res !== void 0 && (_res$data = res.data) !== null && _res$data !== void 0 && _res$data.id) {
          var _res$data2;
          setIntentId(res === null || res === void 0 || (_res$data2 = res.data) === null || _res$data2 === void 0 ? void 0 : _res$data2.id);
        }
      })["catch"](function (err) {
        var _err$response, _err$response2;
        setError((err === null || err === void 0 || (_err$response = err.response) === null || _err$response === void 0 || (_err$response = _err$response.data) === null || _err$response === void 0 ? void 0 : _err$response.debug_message) || (err === null || err === void 0 || (_err$response2 = err.response) === null || _err$response2 === void 0 || (_err$response2 = _err$response2.data) === null || _err$response2 === void 0 ? void 0 : _err$response2.error) || "something went wrong! try again");
      });
      sendEvent(intentId ? "Resend Verification Code" : "Send Verification Code");
    } else {
      setError("Can't be blank");
    }
  };
  var handleLogin = function handleLogin(event) {
    var _document$querySelect, _document$querySelect2;
    var new_ptl_flow = window.location.pathname.includes("/ptl-login");
    event && event.stopPropagation();
    event && event.preventDefault();
    var userType = (_document$querySelect = (_document$querySelect2 = document.querySelector('.tab.active')) === null || _document$querySelect2 === void 0 || (_document$querySelect2 = _document$querySelect2.textContent) === null || _document$querySelect2 === void 0 ? void 0 : _document$querySelect2.trim()) !== null && _document$querySelect !== void 0 ? _document$querySelect : '';
    var emailRegex = /^[a-zA-Z0-9,!#\$%&'\*\+\/=\?\^_`\{\|}~-]+(\.[a-zA-Z0-9,!#\$%&'\*\+\/=\?\^_`\{\|}~-]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.([a-zA-Z]{2,})$/;
    if (!(email !== null && email !== void 0 && email.length)) {
      setError("Can't be blank");
      return;
    }
    if (!(emailRegex !== null && emailRegex !== void 0 && emailRegex.test(email))) {
      setError("Invalid Email");
      return;
    }
    if (isPtlFlow) {
      if (otpLogin) {
        (0, _events.interactedLoginViaOtpByClassroomLinkedParentEvent)(_objectSpread({
          clickedOn: "Submit",
          interactionDetails: "",
          otpEntered: (otp === null || otp === void 0 ? void 0 : otp.length) === 6
        }, referralData));
      } else {
        (0, _events.interactedPtlParentLoginScreenEvent)(_objectSpread({
          clickedOn: "Log in",
          interactionDetails: ""
        }, referralData));
      }
    }
    if (otpLogin) {
      if (otpSent) {
        if (!(otp !== null && otp !== void 0 && otp.length)) {
          setError("Can't be blank");
          return;
        }
        if ((otp === null || otp === void 0 ? void 0 : otp.length) === 6 && intentId) {
          if (isPtlFlow) {
            (0, _events.ptlParentLoginAttemptedEvent)(_objectSpread({
              isEmailUpdated: (params === null || params === void 0 ? void 0 : params.masked_email) !== email,
              loginMethod: otpLogin ? "Verification code" : "Password"
            }, referralData));
          }
          var user_type = new_ptl_flow ? "ptl_parent" : "";
          _api.APIS.verifyOTP(intentId, email, otp, params.user_id, user_type, params.student_id, params.referral_type, params.referrer_code, new_ptl_flow, params === null || params === void 0 ? void 0 : params.trd_id).then(function (res) {
            var _res$data3;
            if (res !== null && res !== void 0 && (_res$data3 = res.data) !== null && _res$data3 !== void 0 && _res$data3.url) {
              var _res$data4;
              //@ts-ignore
              // showFlashMessage(`You have successfully logged in`, "success");
              (0, _pushEventToGTM.pushEventToGTM)('logged_in', {
                user_type: userType,
                label: 'Otp Login'
              });
              window.location.href = (res === null || res === void 0 || (_res$data4 = res.data) === null || _res$data4 === void 0 ? void 0 : _res$data4.url) || "/";
            }
          })["catch"](function (err) {
            var _err$response3, _err$response4;
            (0, _pushEventToGTM.pushEventToGTM)('login_failed', {
              user_type: userType,
              label: 'Otp Login'
            });
            setError((err === null || err === void 0 || (_err$response3 = err.response) === null || _err$response3 === void 0 || (_err$response3 = _err$response3.data) === null || _err$response3 === void 0 ? void 0 : _err$response3.debug_message) || (err === null || err === void 0 || (_err$response4 = err.response) === null || _err$response4 === void 0 || (_err$response4 = _err$response4.data) === null || _err$response4 === void 0 ? void 0 : _err$response4.error) || "something went wrong! try again");
          });
        } else {
          setError("Incorrect verification code. Please double-check the code and try again");
        }
        sendEvent("Submit Login Details : Verification Code");
      } else {
        sendOTP();
      }
    } else {
      if (email && password) {
        if (isPtlFlow) {
          (0, _events.ptlParentLoginAttemptedEvent)(_objectSpread({
            isEmailUpdated: (params === null || params === void 0 ? void 0 : params.masked_email) !== email,
            loginMethod: otpLogin ? "Verification code" : "Password"
          }, referralData));
        }
        _api.APIS.commonPasswordLogin(params.user_id ? params.user_id : email, password, source, params.student_id, params.referral_type, params.referrer_code, new_ptl_flow, params === null || params === void 0 ? void 0 : params.trd_id).then(function (res) {
          var _res$data5;
          if (res !== null && res !== void 0 && (_res$data5 = res.data) !== null && _res$data5 !== void 0 && _res$data5.success) {
            var _res$data6;
            if (res !== null && res !== void 0 && (_res$data6 = res.data) !== null && _res$data6 !== void 0 && _res$data6["goto"]) {
              var _res$data7;
              //@ts-ignore
              // showFlashMessage(`You have successfully logged in`, "success");
              (0, _pushEventToGTM.pushEventToGTM)('logged_in', {
                user_type: userType,
                label: 'Email'
              });
              window.location.href = res === null || res === void 0 || (_res$data7 = res.data) === null || _res$data7 === void 0 ? void 0 : _res$data7["goto"];
            }
          }
        })["catch"](function (err) {
          var _err$response5, _err$response6;
          (0, _pushEventToGTM.pushEventToGTM)('login_failed', {
            user_type: userType,
            label: 'Email'
          });
          setError((err === null || err === void 0 || (_err$response5 = err.response) === null || _err$response5 === void 0 || (_err$response5 = _err$response5.data) === null || _err$response5 === void 0 ? void 0 : _err$response5.debug_message) || (err === null || err === void 0 || (_err$response6 = err.response) === null || _err$response6 === void 0 || (_err$response6 = _err$response6.data) === null || _err$response6 === void 0 ? void 0 : _err$response6.error) || "something went wrong! try again");
          if (isPtlFlow) {
            var _err$response7, _err$response8;
            // not able to send from BE in case of password failed as error is returned by warden
            (0, _events.ptlParentLoginFailedEvent)(_objectSpread({
              isEmailUpdated: (params === null || params === void 0 ? void 0 : params.masked_email) !== email,
              loginMethod: otpLogin ? "Verification code" : "Password",
              errorMessage: (err === null || err === void 0 || (_err$response7 = err.response) === null || _err$response7 === void 0 || (_err$response7 = _err$response7.data) === null || _err$response7 === void 0 ? void 0 : _err$response7.debug_message) || (err === null || err === void 0 || (_err$response8 = err.response) === null || _err$response8 === void 0 || (_err$response8 = _err$response8.data) === null || _err$response8 === void 0 ? void 0 : _err$response8.error)
            }, referralData));
          }
        });
        sendEvent("Submit Login Details : ".concat(primaryInputLabel, "/Password"));
      } else {
        setError("Can't be blank");
      }
    }
  };
  var socialLoginEnabled = (0, _react.useMemo)(function () {
    return showSocialLogin && !window.navigator.userAgent.toLocaleLowerCase().match(/fban|fbav|fbios/); //detects in app facebook browser by user agent
  }, [showSocialLogin, window.navigator.userAgent]);
  var handleForgotPassword = function handleForgotPassword() {
    window.open("/ptl/forgot_password".concat(window.location.search), "_system");
  };
  return {
    handleLogin: handleLogin,
    otpSent: otpSent,
    setOTPSent: setOTPSent,
    setIntentId: setIntentId,
    sendEvent: sendEvent,
    email: email,
    setEmail: setEmail,
    error: error,
    setError: setError,
    otpLogin: otpLogin,
    password: password,
    setPassword: setPassword,
    timer: timer,
    sendOTP: sendOTP,
    otp: otp,
    setOTP: setOTP,
    showResendSuccessMsg: showResendSuccessMsg,
    setOTPLogin: setOTPLogin,
    socialLoginEnabled: socialLoginEnabled,
    maskedEmail: params === null || params === void 0 ? void 0 : params.masked_email,
    params: params,
    emailEvents: emailEvents,
    setEmailEvents: setEmailEvents,
    passwordEvents: passwordEvents,
    setPasswordEvents: setPasswordEvents,
    setFromPage: setFromPage,
    referralData: referralData,
    handleForgotPassword: handleForgotPassword
  };
};